import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ActionMenuComponent } from 'src/app/modules/core/components/action-menu/action-menu.component';

@Component({
    selector: 'topo-action-cell',
    templateUrl: './action-cell.component.html',
    styleUrls: ['./action-cell.component.scss'],
    standalone: false
})
export class ActionCellComponent implements ICellRendererAngularComp, AfterViewInit {
  @ViewChild('menu') menu: ActionMenuComponent;

  document: any;
  location: string;
  actions: any;

  constructor() {}

  ngAfterViewInit() {
    this.menu.location = this.location;
  }

  hideActions(): void {
    this.menu.hideAllBodyMenus();
  }

  agInit(params: any): void {
    this.document = params.data;
    this.location = params.location;
    if (!!params.actions) {
      this.actions = params.actions;
    }
    else if (!!params.getActions) {
      this.actions = params.getActions(this.document);
    }
  }

  refresh(params: any): boolean {
    return false;
  }

  actionClick(event: any): void {
    event.click(this.document);
  }
}
